/* @ngInject */
const resizePosition = ($window) => {
  const resizeToFitPosition = (element) => {
    const divHeight = element.width() / 2.16
    const height = divHeight * 0.45
    element.css('fontSize', height / 1.6)

    const onWindowResize = () => {
      const divHeight = element.width() / 2.16
      const height = divHeight * 0.45
      element.css('fontSize', height / 1.6)
    }

    $window.addEventListener('resize', onWindowResize)

    scope.$on('$destroy', () => {
      element.off()
      $window.removeEventListener('resize', onWindowResize)
    })
  }

  return {
    restrict: 'AE',
    link: (scope, element) => {
      resizeToFitPosition(element)
    },
  }
}

export default resizePosition



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/styles/resizePosition.js